import { langFallback$Fetch } from '../../lang/utils/langfetch'

export class ContactSubcategoriesServiceFetch {
  async fetch(langCode: string): Promise<unknown> {
    return await langFallback$Fetch(
      langCode,
      `/about/api/contact/subcategories/`,
    )
  }
}
